import React, {useState} from 'react';
import PropTypes from 'prop-types';
import zxcvbn from 'zxcvbn';
import {useIntl} from 'react-intl';


import * as passwordConfirmationFormConstants from './passwordConfirmationFormConstants';

import {inputConstants} from '../../../global/Form/Input';

import FormPassword from '../../../global/Form/FormElement/FormPassword';
import PasswordStrength from '../PasswordStrength';
import ValidatingForm from '../../../global/Form/ValidatingForm';


function PasswordConfirmationForm({data, onData}) {

    const {formatMessage} = useIntl();
    const [passwordScore, setPasswordScore] = useState(null);
    const [hasFocus, setHasFocus] = useState(false);

    return (
        <ValidatingForm
            data={data}
            id={'password.form'}
            onIsInvalid={data => onData(data, false)}
            onIsValid={data => onData(data, true)}
            validationSchema={passwordConfirmationFormConstants.SCHEMA_PASSWORD_CONFIRMATION_FORM}
        >
            {({form}) => {

                const onPasswordChange = password => {

                    form.setData({password});

                    const result = zxcvbn(password || '');
                    setPasswordScore(result.score);
                };

                const password = form.getData('password');

                return (
                    <>

                        {/* hidden "username" indicator field for accessibility */}
                        <input
                            style={
                                {
                                    display: 'none'
                                }
                            }
                            autoCapitalize={'off'}
                            autoComplete={'email'}
                            autoCorrect={'off'}
                            name={'email'}
                            type={'email'}
                        />

                        <FormPassword
                            autoComplete={inputConstants.AUTOCOMPLETE_PASSWORD_NEW}
                            error={form.getCurrentError('password')}
                            id={'password'}
                            isRequired={true}
                            label={formatMessage({id: 'password.form.field.password.label'})}
                            name={'password'}
                            onBlur={() => setHasFocus(false)}
                            onChange={password => onPasswordChange(password)}
                            onFocus={() => setHasFocus(true)}
                            placeholder={formatMessage({id: 'password.form.field.password.placeholder'})}
                            value={password}
                        >
                            {hasFocus && password && <PasswordStrength score={passwordScore}/>}
                        </FormPassword>

                        <FormPassword
                            autoComplete={inputConstants.AUTOCOMPLETE_PASSWORD_NEW}
                            error={form.getCurrentError('passwordConfirmation')}
                            id={'passwordConfirmation'}
                            isRequired={true}
                            label={formatMessage({id: 'password.form.field.passwordConfirmation.label'})}
                            name={'passwordConfirmation'}
                            onChange={passwordConfirmation => form.setData({passwordConfirmation})}
                            placeholder={formatMessage({id: 'password.form.field.passwordConfirmation.placeholder'})}
                            value={form.getData('passwordConfirmation')}
                        />

                    </>

                );
            }}
        </ValidatingForm>
    );
}


PasswordConfirmationForm.propTypes = {
    data: PropTypes.shape({
        password: PropTypes.string,
        passwordConfirmation: PropTypes.string
    }),
    onData: PropTypes.func.isRequired
};


export default PasswordConfirmationForm;
